import { RenderDetailViewProps } from 'interfaces/model.interface'

import { ApprovalsData } from 'config/common/baseModel/Approvals'

import Detail from './Detail'

export const IDAApprovalsDetailView = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<ApprovalsData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='candidate'
      approval={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}
